"use client";
import { Button } from "@workspace/sc-ui/components/button";
import { useBffAuth } from "@/components/providers/bff-auth-provider";
import { useLocale, useTranslations } from "next-intl";
import { Locale } from "@/app/[locale]/layout";
import { Spinner } from "@workspace/sc-ui/components/spinner";
import { useRouter } from "next/navigation";

export const SignInButton = () => {
  const locale = useLocale() as Locale;
  const auth = useBffAuth();
  const router = useRouter();
  const t = useTranslations("app.auth");
  if (auth.isLoading) {
    return (
      <Button disabled>
        <Spinner /> {t("loading")}
      </Button>
    );
  }

  if (auth.isAuthenticated) {
    const handleDashboardClick = async () => {
      // Mid: Odświeżamy status przed nawigacją, żeby wykryć wygasłą sesję
      await auth.refresh();

      // Profesor: Po refresh() sprawdzamy aktualny stan - jeśli sesja wygasła,
      // refresh() już zaktualizował state i komponent automatycznie się zaktualizuje
      // (przycisk zmieni się na "Zaloguj"). Jeśli sesja jest aktywna, nawigujemy.
      if (auth.isAuthenticated) {
        router.push(`/${locale}`);
      } else {
        auth.login(`/${locale}`);
      }
    };
    return <Button onClick={handleDashboardClick}>{t("goToDashboard")}</Button>;
  }

  return <Button onClick={() => auth.login(`/${locale}`)}>{t("signIn")}</Button>;
};
